<template>
  <div id="app" :class="{ mobile: isMobile, desktop: !isMobile, small: isSmall, default: !isSmall }" :lang="language">
    <div id="hat">
      <div class="header-container" v-if="!isMobile && extraHeader" v-html="extraHeader"></div>
      <div class="header-container" v-else><img src="/img/logo.png"  class="logo" /></div>
    </div>
    <div id="page-container">
      <span @click="checkFullLoginAndGoTo('/account')"  v-if="isFullLogged==true"  class="fa fa-user-circle logged_user"></span>
      <button v-if="pwaUpdateExists" @click="refreshPwa" style="position:fixed;z-index:99999999999;top:0;left:0">Aggiorna app</button>
      <transition :name="transitionName" v-else>
        <div v-if="loadingLanguages" class="page">
          <div class="flexcentered bigger"><i class="fa fa-fw fa-refresh fa-spin"></i></div>
        </div>
        <router-view v-else-if="!autologging" />
        <div v-else class="page">
          <div class="flexcentered bigger">{{ 'Autologging' | lang }}</div>
        </div>
      </transition>
      <network-spy />
    </div>
    <!-- <div id="page-container">
      <vue-page-transition :name="transitionName2">
        <router-view v-if="!autologging" />
        <div v-else class="page">
          <div class="flexcentered bigger">{{ 'Autologging' | lang }}</div>
        </div>
      </vue-page-transition>
    </div> -->
    <notifier />
    <dialogs-wrapper name="default" />
    <!-- <div v-if="paymentRunning" class="paymentrunning">
      <span v-if="paymentRunning.status === 'pending'">Pagamento in corso</span>
      <span v-if="paymentRunning.status === 'verifying'">Verifica in corso</span>
    </div> -->
    <div v-if="paymentRunning && paymentRunning.status === 'pending'" class="paymentrunning">
      <span>Pagamento in corso</span>
    </div>
    <div v-if="!isMobile && extraFooter" v-html="extraFooter" id="appfooter"></div>
    <div style="display:none;position:absolute;bottom: 1rem;right: 1rem;z-index:1000;color:black;text-shadow:0 0 3px black">{{updatesCounter}}</div>
  </div>
</template>

<script>
// npm run build; cordova build android; cordova run android --device
// npm run dev
import Notifier from './components/Notifier'
import NetworkSpy from './components/NetworkSpy'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import paymentServices from '@/mixins/services/paymentServices'
import UserServices from '@/mixins/services/userServices'
import routeControl from '@/mixins/routeControl'
import store from '@/store'
import storeManifest from '@/storeManifest'
import { Loader } from '@googlemaps/js-api-loader'
import moment from 'moment'
import eticketServices from '@/mixins/services/eticketsServices'

// import Vue from 'vue'


let hslFix = (color) => {
  // var color = 'rgb(255, 15, 120)';
  var matchColors = /hsl\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)/
  var match = matchColors.exec(color)
  if (match !== null) {
    let rgb = hslToRgb(match[1], match[2], match[3])
    // console.log(color, `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`)
    return `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`
  } else {
    matchColors = /hsla\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3}), ?(\d{0,1}(.\d*)?)\)/
    match = matchColors.exec(color)
    if (match !== null) {
      let rgb = hslToRgb(match[1], match[2], match[3])
      // console.log(color, `rgba(${rgb[0]},${rgb[1]},${rgb[2]}, ${match[4]})`)
      return `rgba(${rgb[0]},${rgb[1]},${rgb[2]}, ${match[4]})`
    }
  }
  return color
}
/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {number}  h       The hue
 * @param   {number}  s       The saturation
 * @param   {number}  l       The lightness
 * @return  {Array}           The RGB representation
 */
function hslToRgb(h, s, l) {
  if (h > 1 || l > 1 || s > 1) {
    l = l / 100
    s = s / 100
    h = h / 360
  }
  
  var r, g, b

  if(s == 0){
    r = g = b = l; // achromatic
  } else {
    var hue2rgb = function hue2rgb(p, q, t){
      if(t < 0) t += 1;
      if(t > 1) t -= 1;
      if(t < 1/6) return p + (q - p) * 6 * t;
      if(t < 1/2) return q;
      if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
      return p;
    }

    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

/**
 * Converts an RGB color value to HSL. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and l in the set [0, 1].
 *
 * @param   {number}  r       The red color value
 * @param   {number}  g       The green color value
 * @param   {number}  b       The blue color value
 * @return  {Array}           The HSL representation
 * /
function rgbToHsl(r, g, b){
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min){
        h = s = 0; // achromatic
    }else{
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    return [h, s, l];
} */

let isReachable = (url) => {
  /**
   * Note: fetch() still "succeeds" for 404s on subdirectories,
   * which is ok when only testing for domain reachability.
   *
   * Example:
   *   https://google.com/noexist does not throw
   *   https://noexist.com/noexist does throw
   */
  return fetch(url, { method: 'HEAD', mode: 'no-cors' })
    .then(function(resp) {
      return resp && (resp.ok || resp.type === 'opaque')
    })
    .catch(function(err) {
      console.warn('[conn test failure]:', err)
    })
}

export default {
  name: 'App',
  mixins: [ databaseWrapperMixin, eticketServices, routeControl, UserServices, paymentServices ],
  components: { Notifier, NetworkSpy },
  data () {
    return {
      transitionName: null,
      autologging: true,
      recoveringTickets: null,
      recoveredTickets: 0,
      pwaRegistration: null,
      pwaUpdateExists: false,
      loadingLanguages: true,
      updatesCounter: 0
    }
  },
  methods: {
    loadLanguages () {
      this.loadingLanguages = true
      fetch('/dictionaries.json').then(response => {
        this.loadingLanguages = false
        if (response.ok) {
          response.json().then(value => {
            this.storeLanguage.commit({ type: 'registerDictionaries', value })
          }).catch(e => {
            console.error(e)
            this.storeLanguage.commit({ type: 'registerDictionaries', value: false })
          })
        } else {
          console.error(response)
          this.storeLanguage.commit({ type: 'registerDictionaries', value: false })
        }
      }).catch(e => {
        console.error(e)
        this.storeLanguage.commit({ type: 'registerDictionaries', value: false })
        this.loadingLanguages = false
      })
    },
    updateScreenSize () {
      store.commit({ type: 'registerScreenSize', w: window.innerWidth, h: window.innerHeight })
    },
    async checkSavedLogin () {
      if (localStorage.getItem('login_data')) {
        this.user = { ...JSON.parse(localStorage.getItem('login_data')), Email: null }
        try {
          let profilo = await this._getUserProfile()
          this.userProfile = {
            profilo,
            tessere: []
          }
          this.$set(this.user, 'Email', profilo.Contact.Email)
          let csclist = await this._getUserCSCList()
          this.userProfile.tessere.splice(0, this.userProfile.tessere.length, ...csclist)
          this.internalBus.$emit('notify:success', {
            text: this.dictValue('LoggedIn'),
            key: 'loggedin'
          })
          this.internalBus.$emit('autologin:success')
          if (this.paymentRunning) {
            // if (location.href.indexOf('fakepayment') === -1 && location.href.indexOf('endpayment') === -1) this.goTo('/cart/true', null, true)
            // this.paymentRunning = null
            if (location.href.indexOf('fakepayment') === -1 && location.href.indexOf('endpayment') === -1) this.goTo('/endpayment', true, true)
          } else {
            console.log('NO this.paymentRunning')
          }
          return true
        } catch (e) {
          localStorage.removeItem('login_data')
          console.warn('removed login_data')
          this.user = null
          /* this.internalBus.$emit('notify:error', {
            text: 'Accesso fallito' // this.dictValue('error')
          }) */
          return false
        }
      } else {
        if (this.paymentRunning && location.href.indexOf('endpayment') === -1) this.goTo('/endpayment', true, true)
        else console.log('this.paymentRunning?', this.paymentRunning)
      }
      return undefined
    },
    updateCart () {
      this._getCart(true)
    },
    handleConnectionStatusChange () {
      let wasConnected = store.state.connectionStatus !== 'online'
      if (navigator.onLine) {
        isReachable('/').then(online => {
          console.warn('handleConnectionStatusChange\nprevius connected', wasConnected, 'current connection', online)
          if (online) {
            // handle online status
            store.commit('updateConnectionStatus', 'online')
            /* if (!wasConnected) {
              this.$router.go(0)
            } */
          } else {
            store.commit('updateConnectionStatus', 'no connectivity')
          }
        })
      } else {
        // handle offline status
        store.commit('updateConnectionStatus', 'offline')
        console.warn('offline')
      }
    },
    async checkFirstNotNotifiedPayment () {
      console.log('checkFirstNotNotifiedPayment', this.recoveringTickets, this.user.NotNotifiedPayments)
      if (this.recoveringTickets && !(this.user.NotNotifiedPayments && this.user.NotNotifiedPayments.length)) {
        if (this.recoveredTickets) {
          this.internalBus.$emit('notify:success', {
            text: `${this.recoveredTickets} boughts recovered`,
            timeout: 1000,
            progress: (this.recoveringTickets - this.user.NotNotifiedPayments.length)/this.recoveringTickets,
            key: 'recoveringTickets'
          })
        }
        console.log(`No more NotNotifiedPayments. Recovered ${this.recoveredTickets} of ${this.recoveringTickets}`)
        this.recoveringTickets = false
        return
      }
      /* this.internalBus.$emit('notify:progress', {
        text: `Recovering ${this.recoveringTickets - this.user.NotNotifiedPayments.length} of ${this.recoveringTickets}`,
        timeout: 100000,
        progress: (this.recoveringTickets - this.user.NotNotifiedPayments.length)/this.recoveringTickets,
        key: 'recoveringTickets'
      }) */
      console.log(this.user.NotNotifiedPayments)
      await this._checkPaymentStatus(this.user.NotNotifiedPayments[0].PaymentId, this.user.NotNotifiedPayments[0].OrderId).then(status => {
        console.log("_checkPaymentStatus response from App.vue", status)
        // status = status.PaymentStatus
        if (status.PaymentStatus.toLowerCase() === 'paymentaccepted') { // successful
          // this.paymentDone(true)
          console.warn('TODO gestione biglietto in risposta')
          this.user.NotNotifiedPayments.shift()
          this.recoveredTickets += 1
        } else if (status.PaymentStatus.toLowerCase() === 'paymentdenied') { // failed
          this.user.NotNotifiedPayments.shift()
        } else if (status.PaymentStatus.toLowerCase() === 'paymentinprogress') { // boh, retry
          // this.callCycleTimeout = setTimeout(this.callCycle, 300)
        } else { // unexpected!
          console.warn(`Unexpected value ${status.PaymentStatus} from checkOrderStatus!`)
          // this.paymentDone(false)
          this.user.NotNotifiedPayments.shift()
        }
      }).catch(err => {
        console.warn(err)
      })
      setTimeout(this.checkFirstNotNotifiedPayment, 1000)
    },
    loadOfflinePages () {
      let promise1 = new Promise((resolve, reject) => {
        fetch('/manual.html').then(response => {
          if (response.ok) {
            response.text().then(data => {
              storeManifest.commit({ type: 'registerManualPage', html: data })
              resolve(data)
            }).catch(e => {
              storeManifest.commit({ type: 'registerManualPage', html: null })
              reject(e)
            })
          } else {
            reject(e => {
              storeManifest.commit({ type: 'registerManualPage', html: null })
              reject(e)
            })
          }
        }).catch(e => {
          storeManifest.commit({ type: 'registerManualPage', html: null })
          reject(e)
        })
      })
      let promise2 = new Promise((resolve, reject) => {
        fetch('/mobile.html').then(response => {
          if (response.ok) {
            response.text().then(data => {
              storeManifest.commit({ type: 'registerMobilePage', html: data })
              resolve(data)
            }).catch(e => {
              storeManifest.commit({ type: 'registerMobilePage', html: null })
              reject(e)
            })
          } else {
            reject(e => {
              storeManifest.commit({ type: 'registerMobilePage', html: null })
              reject(e)
            })
          }
        }).catch(e => {
          storeManifest.commit({ type: 'registerMobilePage', html: null })
          reject(e)
        })
      })
      return Promise.all([promise1, promise2])
    },
    loadManifest () {
      return new Promise((resolve, reject) => {
        fetch('/manifest.json?r=' + Math.random()).then(response => {
          if (response.ok) {
            response.json().then(data => {
              // console.log(JSON.parse(JSON.stringify(data)))
              storeManifest.commit({ type: 'registerManifest', data })
              let isValidUrl = (str) => {
                return str && (str.startsWith('http://') || str.startsWith('https://'))
              }
              if (data.extraHeader && isValidUrl(data.extraHeader)) storeManifest.dispatch('downloadHeaderHtmlFromUrl')
              if (data.extraFooter && isValidUrl(data.extraFooter)) storeManifest.dispatch('downloadFooterHtmlFromUrl')
              // if (data.extraMobilePage && isValidUrl(data.extraMobilePage)) storeManifest.dispatch('downloadExtraPageHtmlFromUrl')

              if (data.colorPrimary) document.documentElement.style.setProperty('--primary', hslFix(data.colorPrimary))
              if (data.colorPrimaryTransparent) document.documentElement.style.setProperty('--primarytransparent', hslFix(data.colorPrimaryTransparent)) // not used
              // if (data.colorSecondary) document.documentElement.style.setProperty('--secondary', hslFix(data.colorSecondary))
              if (data.colorText) document.documentElement.style.setProperty('--black', hslFix(data.colorText))
              if (data.colorPopupGlass) document.documentElement.style.setProperty('--blacktransparent', hslFix(data.colorPopupGlass))
              if (data.colorBackground) document.documentElement.style.setProperty('--white', hslFix(data.colorBackground))
              if (data.colorBackgroundTransparent) document.documentElement.style.setProperty('--whitetransparent', hslFix(data.colorBackgroundTransparent))
              if (data.colorAuxText) document.documentElement.style.setProperty('--gray', hslFix(data.colorAuxText))
              if (data.colorWarning) document.documentElement.style.setProperty('--orange', hslFix(data.colorWarning))
              if (data.colorOk) document.documentElement.style.setProperty('--green', hslFix(data.colorOk))
              if (data.colorError) document.documentElement.style.setProperty('--red', hslFix(data.colorError))
              resolve(data)
            }).catch(reject)
          } else {
            reject(response)
          }
        }).catch(reject)
      })
    },
    async managePaymentsRecovery (payments) {
      console.log('payments', payments)
      this.recoveredTickets = 0
      this.recoveringTickets = payments.length
      for (let i = 0; i < payments.length; i++) {
        let p = payments[i]
        await this._checkPaymentStatus(p.PaymentId, p.OrderId, p.usertoken).then(status => {
          console.log("_checkPaymentStatus response from App.vue", status)
          // status = status.PaymentStatus
          if (status.PaymentStatus.toLowerCase() === 'paymentaccepted') { // successful
            // this.paymentDone(true)
            console.warn('TODO gestione biglietto in risposta')
            this.recoveredTickets += 1
          } else if (status.PaymentStatus.toLowerCase() === 'paymentdenied') { // failed
            // nada
          } else if (status.PaymentStatus.toLowerCase() === 'paymentinprogress') { // boh, retry
            // nada
          } else { // unexpected!
            console.warn(`Unexpected value ${status.PaymentStatus} from checkOrderStatus!`)
          }
        }).catch(err => {
          console.warn(err)
        })
      }
      if (this.recoveredTickets) {
        this.internalBus.$emit('notify:success', {
          text: this.dictValue('TicketsRecovered', null, { ntickets: this.recoveredTickets }),
          timeout: 1000,
          // progress: i / this.recoveringTickets,
          key: 'recoveringTickets'
        })
      }
      this.recoveringTickets = false
    },
    updateEticketVadValidations (ids) {
      this._updateValidations(ids).then(resp => {
        resp.forEach(r => {
          // this.dwSetTicketVadValidated(r.EticketId, r.Validated)
          this.dwUpdateTicketData(r.EticketId, r)
        })
      })
    },
    updateAvailable (evt) {
      console.log('pwa updateAvailable!!', evt)
      /*this.pwaRegistration = evt.detail
      this.pwaUpdateExists = true*/
    },
    refreshPwa () {
      console.log('refreshPwa!!')
      /*this.pwaUpdateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // Send message to SW to skip the waiting and activate the new SW
      //this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })

      caches.keys().then(function(names) {
        for (let name of names) caches.delete(name)
        window.location.reload(true)
      })*/
    }
  },
  async mounted () {
    this.loadLanguages()
    window.VUEAPP = this

    // Listen for our custom event from the SW registration
    // document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    
    // Prevent multiple refreshes
    /*navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('controllerchange')
      if (this.refreshing) return
      this.refreshing = true
      // Here the actual reload of the page occurs
      window.location.reload()
    })*/

    let v = localStorage.getItem('updatesCounter')
    if (!v || v === 'null') {
      v = 0
    }
    localStorage.setItem('updatesCounter', parseInt(v) + 1)
    console.warn('App.vue MOUNTED')

    setInterval(() => {
      let v = localStorage.getItem('updatesCounter')
      if (!v || v === 'null') {
        v = 0
      }
      this.updatesCounter = v
    }, 1000)

    this.internalBus.$on('startNotNotifiedPaymentsManagement', this.managePaymentsRecovery)

    // manage online/offline status
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    if (connection) {
      connection.addEventListener('change', this.handleConnectionStatusChange)
    }
    window.addEventListener('online', this.handleConnectionStatusChange)
    window.addEventListener('offline', this.handleConnectionStatusChange)
    this.handleConnectionStatusChange()

    // wait for manifest data and offline pages
    try { await this.loadManifest() } catch(e) { console.warn(e) }
    try { await this.loadOfflinePages() } catch(e) { console.warn(e) }

    // load and set google directions stuff
    const loader = new Loader({
      apiKey: this.manifest.googleKey,
      version: "weekly",
      libraries: ['places']
    })
    loader.load()

    // load user cart
    this.internalBus.$on('updateCart', this.updateCart)
    this.internalBus.$on('updateEticketVadValidations', this.updateEticketVadValidations)

    // moment
    moment.locale(this.language.substring(0, 2))

    // manage focused/blurred app status
    window.onblur = () => {
      store.commit({ type: 'updateValue', value: false, key: 'appIsFocused' })
    }
    window.onfocus = () => {
      store.commit({ type: 'updateValue', value: true, key: 'appIsFocused' })
    }

    // manage window resize
    window.addEventListener('resize', this.updateScreenSize)
    this.updateScreenSize()
    
    // set token autorefresh
    setInterval(() => {
      // console.log('this.user && this.user.Token', this.user && this.user.Token)
      if (this.user && this.user.Token) {
        this._refreshToken()
      }
    }, 40000)

    // Do login if possible
    /* let done = */ await this.checkSavedLogin()
    if (this.$route.path === '/updateemail') {
      // alert('update email')
      let email = this.$route.query.email
      let token = this.$route.query.token
      let guid = this.$route.query.guid
      this.internalBus.$emit('notify:progress', {
        text: this.dictValue('EmailVerificationRunning'),
        key: this.notifierKey
      })
      try {
        await this._confirmMailUpdate(email, token, guid)
        this.internalBus.$emit('notify:success', {
          text: this.dictValue('EmailVerificationOk'),
          key: this.notifierKey
        })
        try {
          let profilo = await this._getUserProfile()
          this.$set(this.user, 'Email', profilo.Contact.Email)
        } catch (e) {
          this.$set(this.user, 'Email', email)
        }
      } catch (e) {
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured'),
          key: this.notifierKey,
          timeout: 3000
        })
      }
      this.goTo('/', true)
    } else if (this.$route.path !== '/' && location.href.indexOf('passwordrecoveryend') === -1 && location.href.indexOf('registrationend') === -1 && location.href.indexOf('fakepayment') === -1 && location.href.indexOf('endpayment') === -1) {
      this.goTo('/')
    }

    /* get manual page */
    /*this.$http.get('manual.html').then(response => {
      this.storeManifest.commit({ type: 'registerManualHtml', html: response.body })
    }).catch(() => {
      this.storeManifest.commit({ type: 'registerManualHtml', html: null })
    })*/
    /* end get manual page */

    this.internalBus.$on('unauthorizedNetworkCall', this.logout)

    this.autologging = false
  },
  beforeDestroy () {
    this.internalBus.$off('updateCart', this.updateCart)
    this.internalBus.$off('updateEticketVadValidations', this.updateEticketVadValidations)
    clearInterval(this.interval)
  },
  watch: {
    '$route' (to, from) {
      let goingBack = !!window.goingBack
      if (window.goingBack === undefined) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        goingBack = toDepth < fromDepth
      }
      this.transitionName = to.path === '/' || goingBack ? 'slide-right' : 'slide-left'
      /* this.transitionName2 = to.path === '/' || goingBack ? 'fade-in-right' : 'fade-in-left'
      if (!this.isMobile) {
        this.transitionName2 = 'overlay-left-right'
      } */
      window.goingBack = undefined
      // window.lastGoingBack = goingBack
      window.previousRoute = from
      // console.log(from, to)
    },
    language (value) {
      moment.locale(value.substring(0, 2))
    },
    user (newV) {
      if (!newV) {
        this.userProfile = null
      }
      this.updateCart()
    }
  }
}

// let alreadyAdded = false
</script>

<style lang="scss">
@import '@/assets/common.scss';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.page {
  transition: all .5s ease-in-out;
  opacity: 1;
}
.slide-left-enter, .slide-right-leave-active {
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  transform: translate(-30px, 0);
}

#app.desktop {
  .slide-left-enter, .slide-right-leave-active {
    transform: none; // translate(0, 30px);
  }
  .slide-left-leave-active, .slide-right-enter {
    transform: none; // translate(0, -30px);
  }
}

.slide-left-enter {
  opacity: 0;
}
.slide-left-leave-active {
  opacity: 1;
}
.slide-right-enter {
  opacity: 0;
}
.slide-right-leave-active {
  opacity: 1;
}

.paymentrunning {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--whitetransparent);
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
}
#app.desktop .paymentrunning {
  font-size: 3rem;
}

</style>
